
function doClaim(data) {
	return {
		url: `/morty/assistant/claim/${data.requestKey}`,
		method: 'POST',
		body: {
			user_key: `${data.userKey}`
		}
	};
}

export { doClaim };
